import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import REDropdown from '../residents/residentSetting/REDropdown/REDropdown';
import DatePicker from 'react-datepicker';
import ApiGo from '../../actions/ApiGo';
import { ADD_RESIDENTS_ARRAY } from '../../stores/reducer_residentsArray';
import { ADD_RESPONSE, ADD_RESPONSE_JSON } from '../../stores/reducer_add';
import { useDispatch } from 'react-redux';
import { CTXHide } from '../Layout';
import Account from '../../actions/Account';
import _ from 'lodash';
import BarcodeScanner, { BarcodeTest, ScannerTest } from './BarcodeScanner';
import PopConfirm from '../popUp/PopConfirm';
import ConfigHandler from '../../actions/ConfigHandler';

//for 大同使用
const soap_patient = {
  BIRTHDATE: '',
  PATIENTNAME: '',
  PATNO: '',
  SEX: '',
  WARDBEDNO: '',
};
const AddResident = () => {
  // i18n翻譯
  const { t } = useTranslation();
  const is_Kmuh = ConfigHandler.isKmuh;
  // use contex hide
  const ctx_hide = useContext(CTXHide);
  const [mustFilled, setMustFilled] = useState(false);
  // --------------- redux ---------------
  const [UpdateRedux, setUpdateRedux] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (UpdateRedux) {
      ApiGo.getResidents()
        .then((res) => {
          dispatch(ADD_RESIDENTS_ARRAY(res));
          ctx_hide();
        })
        .catch();
    }
  }, [UpdateRedux]);
  // --------------- redux ---------------

  // ##### STEP1：製作各欄位提取方式 #####

  // 各欄位 input value
  const [inputData, setInputData] = useState({
    first_name: '',
    last_name: '',
    gender: '',
    birthday: '',
    cell_phone: '',
    height: 0,
    weight: 0,
    address: '',
    emergency_contact: '',
    home_phone: '',
    blood_type: '',
    special_conditions: '',
    med_record_num: '',
    // "room_name":"" // 房號
  });

  function handleInput(_value, _index) {
    let _addText = {};
    switch (_index) {
      case 0:
        _addText = { last_name: _value };
        break;
      case 1:
        _addText = { first_name: _value };
        break;
      case 2:
        _addText = { med_record_num: _value };
        break;
      case 3:
        _addText = { special_conditions: _value };
        break;
      case 4:
        _addText = { height: _value };
        break;
      case 5:
        _addText = { weight: _value };
        break;
      case 7:
        _addText = { address: _value };
        break;
      case 8:
        _addText = { emergency_contact: _value };
        break;
      case 9:
        _addText = { home_phone: _value };
        break;
      case 10:
        _addText = { cell_phone: _value };
        break;
      // case 11: _addText = {room_name:_value}; break; // 房號
      default:
        break;
    }
    setInputData({
      ...inputData,
      ..._addText,
    });
  }

  // 選單內容--生日   ---生日性別格式不同另外做
  const [birth_date, setBirth_date] = useState(null); // residents.birthday

  // 選單內容--性別
  const [gender, setGender] = useState(t('GLOBAL.FEMALE')); // residents.gender
  const [genderSwitch, setGenderSwitch] = useState(false); // 設定開、關
  function SwitchFunction() {
    setGenderSwitch(!genderSwitch);
  } // 開、關的按鈕
  // 血型
  const [blood_type, setBlood_type] = useState(null); // residents.blood_type
  const [blood_type_RH, setBlood_type_RH] = useState(null); // residents.blood_type
  // 選單內容--生日日期
  const [CalSwitch, setCalSwitch] = useState(false);
  // function toggleCal(){ setCalSwitch(!CalSwitch) } // 開、關的按鈕

  // 處理 kmtth soap 搜尋
  const [section, setSection] = useState(t('RESIDENTS.STAY_IN'));
  const [sectionSwitch, setSectionSwitch] = useState(false);
  function SwitchSectionFunc() {
    setSectionSwitch(!sectionSwitch);
  } // 開、關的按鈕
  const [med_record_num, setMed_record_num] = useState(''); // residents.first_name? med_record_num
  const [focus, setFocus] = useState(false);
  const [soapResult, setSoapResult] = useState(soap_patient);
  const [soapPatientBool, setSoapPatientBool] = useState(false);
  const [scannerBool, setScannerBool] = useState(false);
  const [scannedCode, setScannedCode] = useState(null);
  const [btnIsLoading, setBtnIsLoading] = useState(false); //針對新增受護者的確認判別
  const [pop, setPop] = useState({
    open: false,
    content: '',
    parameter: [],
    combinedData: {},
  });

  const togglePop = useCallback(() => {
    setPop({
      open: false,
      content: '',
      parameter: [],
      status: '',
      combinedData: {},
    });
  }, []);

  const handleScan = (code) => {
    setScannedCode(code);
  };

  function handleSoapSearch(value) {
    setMed_record_num(value);
    handleInput(value, 2);

    if (is_Kmuh) {
      setFocus(true);
      let _hosType = 'IPD';
      if (section === '急診') {
        _hosType = 'ER';
      }
      if (value.length <= 7) {
        return;
      }
      ApiGo.getPatientData_chartNo(_hosType, value)
        .then((res) => {
          setSoapResult(res);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }
  function handleSoapClick() {
    setInputData({
      first_name: '',
      last_name: '',
      gender: 'F',
      birthday: new Date(),
      cell_phone: '',
      height: 0,
      weight: 0,
      address: '',
      emergency_contact: '',
      home_phone: '',
      blood_type: '',
      special_conditions: '',
      med_record_num: '',
      // "room_name":"" // 房號
    });
    setFocus(false);
    setSoapPatientBool(true);
  }
  function searchKeyPress(key) {
    setFocus(false);
    if (key === 'Enter' && soapResult?.PATIENTNAME?.length > 0) {
      setSoapPatientBool(true);
    }
  }
  useEffect(() => {
    if (!soapPatientBool) {
      return;
    }
    setInputData({
      first_name: soapResult.WARDBEDNO,
      last_name: soapResult.PATIENTNAME,
      gender: soapResult.SEX === 'F' ? t('GLOBAL.FEMALE') : t('GLOBAL.MALE'),
      birthday: new Date(Date.parse(soapResult.BIRTHDATE)),
      cell_phone: '',
      height: 0,
      weight: 0,
      address: '',
      emergency_contact: '',
      home_phone: '',
      blood_type: '',
      special_conditions: '',
      med_record_num: soapResult.PATNO,
      // "room_name":"" // 房號
    });
    let _g = soapResult.SEX === 'F' ? t('GLOBAL.FEMALE') : t('GLOBAL.MALE');
    setGender(_g);
    setBirth_date(new Date(soapResult.BIRTHDATE));
    setSoapPatientBool(false);
  }, [soapPatientBool]);
  // 處理日期在這--------------------------
  const [dayMonth, setDayMonth] = useState('');

  const handleChange = (date) => {
    const utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()));
    setBirth_date(utcDate);
    setDayMonth(`${date.getFullYear()}/${date.getMonth() + 1}/${date.getDate()}`);
    setCalSwitch(false);
  };

  const handleClick = (e) => {
    e.preventDefault();
    setCalSwitch(!CalSwitch);
  };
  // 處理日期在這--------------------------

  // ##### STEP2：API_PUT #####
  const debouncedApiPut = _.debounce(
    async () => {
      if (btnIsLoading) return;
      if ((birth_date === null && inputData.med_record_num === '') || inputData.first_name === '' || inputData.last_name === '') {
        setPop({
          open: true,
          status: 'addResident',
        });
        setBtnIsLoading(false);
        return;
      }
      setBtnIsLoading(true);
      setUpdateRedux(false);
      // 整理要put的資料
      const _Data = {
        ...inputData,
        blood_type: `${blood_type}_${blood_type_RH}`,
        gender,
        birthday: birth_date ? birth_date.toISOString() : null,
      };
      const _acc = new Account();
      const combinedData = {
        accountInfo: {
          email: _acc.email,
          role: _acc.role,
        },
        residentInfo: _Data,
      };
      //新版
      try {
        await ApiGo.postCreate_Residents(combinedData);
        dispatch(ADD_RESPONSE({ status: 200, statusText: 'success', type: 'create_resident' }));
        setUpdateRedux(true);
      } catch (err) {
        if (err.status === 400) {
          const responseData = await err.response;
          setPop({
            open: true,
            status: 'addResidentError_dbLimit',
            parameter: responseData.detail,
          });
        } else if (err.status === 409) {
          const responseData = await err.response;
          setPop({
            open: true,
            status: 'same_Resident',
            parameter: responseData.detail,
            combinedData,
          });
        } else if (err.status === 403) {
          setPop({
            open: true,
            status: 'addResidentError',
          });
        } else {
          dispatch(ADD_RESPONSE({ status: err.status, statusText: err.statusText, type: 'create_resident' }));
          setUpdateRedux(true);
        }
      } finally {
        setBtnIsLoading(false);
      }
    },
    500,
    { leading: false, trailing: true }
  );

  let _inputArr = ['GLOBAL.NAME', 'GLOBAL.BED_NO', 'RESIDENTS_SETTING.MEDICAL_RECORD_NUMBER', 'GLOBAL.NAME', 'GLOBAL.HOME_PHONE', 'GLOBAL.CELLPHOME_NUMBER'];

  let _inputDiv = _inputArr.map((res, index) => {
    let _id = index === 0 ? 'last_name' : 'first_name';
    return index === 0 || index === 1 ? (
      <div className="w-100 h-100" key={res}>
        <div key={index} className="w-100 h-100 fx-d-c fx-fefs">
          <div className="h-80 flied w-100">
            <div className="fx-ccc w-50 h-75 title_typeA">
              <span className="font-red font-xl">*</span>
              {t(res)}
            </div>
            <div
              className={`fx-ccc w-50 h-75 content_input font-ml ${mustFilled && inputData[_id] === '' ? 'must_Filled' : null}`}
              onClick={() => {
                setMustFilled(false);
              }}>
              <input
                type="text"
                value={inputData[_id]}
                onChange={(e) => {
                  handleInput(e.target.value, index);
                }}
              />
            </div>
          </div>
        </div>
      </div>
    ) : index === 2 ? (
      <div className="h-10" key={res}>
        <div key={index} className="h-100 flied">
          <div className="fx-ccc w-50 h-75 title_typeA">
            <span className="font-blue font-xl">*</span>
            {t(res)}
          </div>
          <div className="w-50 h-75 content_input">
            <input
              type="text"
              value={med_record_num}
              onChange={(e) => {
                handleSoapSearch(e.target.value);
              }}
              onKeyDown={(e) => {
                is_Kmuh && searchKeyPress(e.key);
              }}
            />
            {/* {focus?<div className='pos-a w-10 fx-ccc pad-5 r'>
                        {soapResult.PATNO===""?<div className='selecBox w-100 fx-ccc'>請輸入完整病歷號碼</div>:
                            soapResult?.PATIENTNAME?.length>0 && <div className='selecBox w-100 fx-ccc' onClick={handleSoapClick}>{soapResult.WARDBEDNO}-{soapResult.PATIENTNAME}</div>
                        }
                    </div>:null} */}
            {is_Kmuh && focus && (
              <div className="pos-a w-10 fx-ccc pad-5 r">
                {soapResult.PATNO === '' ? (
                  <div className="selecBox w-100 fx-ccc">請輸入完整病歷號碼</div>
                ) : (
                  soapResult?.PATIENTNAME?.length > 0 && (
                    <div className="selecBox w-100 fx-ccc" onClick={handleSoapClick}>
                      {soapResult.WARDBEDNO}-{soapResult.PATIENTNAME}
                    </div>
                  )
                )}
              </div>
            )}
          </div>
        </div>
      </div>
    ) : (
      <div className="w-50 h-75 fx-ccc" key={res}>
        <div key={index} className="fx-ccc w-100 h-100 title_typeA">
          {t(res)}
        </div>
        <div className="fx-ccc w-100 h-100 content_input">
          <input
            type="text"
            maxLength="10"
            onChange={(e) => {
              handleInput(e.target.value.replace(/^[0-9]/g, ''), index + 5);
            }}
          />
        </div>
      </div>
    );
  });

  return (
    <>
      {pop.open ? <PopConfirm content={pop.content} status={pop.status} title={'新增受護者警示'} hide={togglePop} parameter={pop.parameter} resident_data={pop.combinedData} setPop={setPop} setUpdateRedux={setUpdateRedux} /> : null}
      <div className="fx-d-r gap10">
        <div className="fx-ccc">
          <span className="font-red font-xl">*</span>
          {t('GLOBAL.REQUIRED')}
        </div>
        <div className="fx-ccc">
          <span className="font-blue font-xl">*</span>
          {t('GLOBAL.ONE_REQUIRED')}
        </div>
      </div>
      {/* 房號欄位 */}
      {/* <div className='w-100 h-10 wrap-personal'>
        <div className='w-100 h-100'>
            <div className='w-100 h-100 fx-d-c fx-fefs'>
                <div className='h-80 flied w-100'>
                    <div className="fx-ccc w-50 h-75 title_typeA">{t('GLOBAL.ROOM_NO')}</div>
                        <div className="fx-ccc w-50 h-75 content_input">
                            <input type="text" onChange={(e)=>{
                                const trimmedValue = e.target.value.trim();
                                handleInput(trimmedValue, 11)
                            }}/>
                    </div>
                </div>
            </div>
        </div>
        <div className="w-100"></div>
        <div className="w-100"></div>
    </div> */}
      <div className="w-100 h-10 wrap-personal">
        {_inputDiv[0]}
        {_inputDiv[1]}
        <div className="w-100"></div>
      </div>
      <div className="wrap-personal w-100 h-80">
        <div className="h-100 l-s-container">
          {_inputDiv[2]}
          <div className="h-10 flied">
            <div className="fx-ccc w-50 h-75 title_typeA">{t('RESIDENTS_SETTING.MEMO')}</div>
            <div className="fx-ccc w-50 h-75"></div>
          </div>
          <div className="h-70 content_input_b">
            <textarea
              onChange={(e) => {
                handleInput(e.target.value, 3);
              }}
            />
          </div>
          {/* <div className="h-10 flied"></div> */}
        </div>

        <div className="h-100 r-s-container">
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">
              <span className="font-blue font-xl">*</span>
              {t('GLOBAL.BIRTHDAY')}
            </div>
            <div className="fx-ccc w-25 h-75 content_input" onClick={handleClick}>
              <div className="inner">{dayMonth ? dayMonth : <span style={{ color: '#999' }}>{t('GLOBAL.SELECT_DATE')}</span>}</div>
              {CalSwitch && (
                <div className="pos-a" style={{ zIndex: 20 }} onClick={(e) => e.stopPropagation()}>
                  <DatePicker selected={birth_date} onChange={handleChange} inline peekNextMonth showMonthDropdown showYearDropdown dropdownMode="select" maxDate={new Date()} />
                </div>
              )}
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeB">{t('RESIDENTS_SETTING.ADVANCED_PROFILE')}</div>
          </div>
          <div className="h-10 flied ">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.HEIGHT')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                maxLength="3"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  handleInput(value, 4);
                }}
              />
              <div className="content-unit">{t('GLOBAL.CENTIMETER')}</div>
            </div>
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.WEIGHT')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <input
                type="text"
                maxLength="3"
                onChange={(e) => {
                  const value = e.target.value.replace(/[^0-9]/g, '');
                  handleInput(value, 5);
                }}
              />
              <div className="content-unit">{t('GLOBAL.KILOGRAM')}</div>
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.GENDER')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <div className="dropdown-container">
                <REDropdown toggleDropdown={SwitchFunction} closeToggle={genderSwitch} data={{ id: 0, keys: [t('GLOBAL.FEMALE'), t('GLOBAL.MALE')], data: gender }} returnData={setGender} />
              </div>
            </div>
            <div className="fx-ccc w-25 h-75 title_typeA">{t('RESIDENTS.UNIT')}</div>
            <div className="fx-ccc w-25 h-75 content_input">
              <div className="dropdown-container">
                <REDropdown toggleDropdown={SwitchSectionFunc} closeToggle={sectionSwitch} data={{ id: 0, keys: [t('RESIDENTS.STAY_IN'), t('RESIDENTS.ER'), t('RESIDENTS.CLINIC')], data: section }} returnData={setSection} />
              </div>
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.BLOOD_TYPE')}</div>
            <div className="fx-ccc w-75 h-75 content_input font-s">
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('A');
                }}
                defaultChecked={blood_type === 'A'}
              />
              <div>A</div>
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('B');
                }}
                defaultChecked={blood_type === 'B'}
              />
              <div>B</div>
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('AB');
                }}
                defaultChecked={blood_type === 'AB'}
              />
              <div>AB</div>
              <input
                type="radio"
                style={{ width: '10%' }}
                name="radio"
                onClick={() => {
                  setBlood_type('O');
                }}
                defaultChecked={blood_type === 'O'}
              />
              <div>O</div>
              <div className="fx-ccc h-75 RH-blood">
                <input
                  type="radio"
                  style={{ width: '20%' }}
                  name="radioRH"
                  onClick={() => {
                    setBlood_type_RH('-');
                  }}
                  defaultChecked={blood_type_RH === '-'}
                />
                <div>{t('GLOBAL.RH_NEGATIVE')}</div>
                <input
                  type="radio"
                  style={{ width: '20%' }}
                  name="radioRH"
                  onClick={() => {
                    setBlood_type_RH('-');
                  }}
                  defaultChecked={blood_type_RH === '+'}
                />
                <div>{t('GLOBAL.RH-POSITIVE')}</div>
              </div>
            </div>
          </div>
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeA">{t('GLOBAL.ADDRESS')}</div>
            <div className="fx-ccc w-75 h-75 content_input">
              <input
                type="text"
                onChange={(e) => {
                  handleInput(e.target.value, 7);
                }}
              />
            </div>
          </div>
          {/* <div className="h-10 flied"></div> */}
          <div className="h-10 flied">
            <div className="fx-ccc w-25 h-75 title_typeB">{t('GLOBAL.EMERGENCY_CONTACT')}</div>
          </div>
          <div className="h-10 flied">
            {_inputDiv[3]}
            {_inputDiv[4]}
          </div>
          <div className="h-10 flied">{_inputDiv[5]}</div>
          {/* <div className="h-10 flied"></div> */}
        </div>
      </div>
      {/* <div className='border'>
        <div onClick={()=>{setScannerBool(!scannerBool)}}>qrcode scanner</div>
        <div className='123'>
            {scannerBool? <BarcodeScanner onScan={handleScan} />:null}
            {scannedCode && <p>Scanned Code: {scannedCode}</p>}
        </div>
    </div> */}
      <div className="wrap-personal-btn w-100 h-10 fx-fec">
        <div className="h-100 l-s-container fx-d-r">
          <div className="fx-ccc w-50 btn_type" onClick={debouncedApiPut}>
            {t('GLOBAL.CONFIRM')}
          </div>
          <div className="fx-ccc w-50 btn_type" onClick={ctx_hide}>
            {t('GLOBAL.CANCEL')}
          </div>
        </div>
      </div>
    </>
  );
};
export default AddResident;

// function InputDiv(props){
//     return <div className='w-100 h-100' key={props.res}>
//         <div className='w-100 h-100 fx-d-c fx-fefs'>
//             <div className="h-80 flied w-100">
//                 <div className="fx-ccc w-50 h-75 title_typeA">{t(props.res)}</div>
//                 <div className={`fx-ccc w-50 h-75 content_input font-ml ${mustFilled&&inputData[_id]===''?"must_Filled":null}`} onClick={()=>{setMustFilled(false)}}>
//                     <input type="text" value={props.inputData} onChange={(e)=>{handleInput(e.target.value, index)}} />
//                 </div>
//             </div>
//         </div>
//     </div>
// }
